export default __webpack_public_path__ + "static/media/trailRiderBanner.0322a749.png";